 <template>
    <v-overlay :model-value="loading" class="align-center justify-center">
        <LoadingComponent />
    </v-overlay>
    <v-row v-if="success" style="margin-top: 20px; margin-bottom: 20px">
        <v-col>
            <v-alert type="success" title="Success!"></v-alert>
        </v-col>
    </v-row>
    <v-row>
        <!--Dialog for Barcode Scanner-->
        <v-dialog v-model="scanningBarCode" :retain-focus="false">
            <v-container fluid>
                <div class="full-width-card-alt">
                    <StreamBarcodeReader
                        v-if="scanningBarCode"
                        @decode="onDecodeBC"
                    ></StreamBarcodeReader>

                    <v-btn
                        color="red"
                        variant="flat"
                        prepend-icon="mdi:mdi-window-close"
                        @click="closeBarCodeScanner"
                    >
                        Close
                    </v-btn>
                </div>
            </v-container>
        </v-dialog>
        <!--End of Dialog-->
        <v-col cols="12" sm="3">
            <span class="text-h5">
                Job Number
                <v-tooltip v-if="!prefillData?.JobNum" v-model="showJobNumbTooltip" location="end">
                    <template v-slot:activator="{ props }">
                        <v-btn
                            size="x-small"
                            icon
                            v-bind="props"
                            @click="showJobNumbTooltip = !showJobNumbTooltip"
                        >
                            <v-icon color="blue-lighten-1"
                                >mdi:mdi-comment-question-outline</v-icon
                            >
                        </v-btn>
                    </template>
                    <span
                        >Type the Job Number and press Enter or use the Scanner
                        Button</span
                    >
                </v-tooltip>
            </span>
            <v-text-field
                v-model="jobNumber"
                :clearable="!prefillData?.JobNum"
                label="Job Number"
                variant="underlined"
                :readonly="!!prefillData?.JobNum"
                v-on:keydown.enter="getJobInfo"
            ></v-text-field>

            <v-alert v-if="errorJobNum" color="red"
                >{{ errorMessageJobNum }}
            </v-alert>
        </v-col>

        <v-col cols="12" sm="1">
            <v-btn
                v-if="!prefillData?.JobNum"
                class="mt-9"
                icon="mdi:mdi-barcode-scan"
                @click="openQRScanner"
            ></v-btn>
            <v-dialog v-model="scanningQR" :retain-focus="false">
                <v-container fluid>
                    <div class="full-width-card-alt">
                        <StreamBarcodeReader
                            v-if="scanningQR"
                            @decode="onDecodeQR"
                        ></StreamBarcodeReader>

                        <v-btn
                            color="red"
                            variant="flat"
                            prepend-icon="mdi:mdi-window-close"
                            @click="closeQRScanner"
                        >
                            Close
                        </v-btn>
                    </div>
                </v-container>
            </v-dialog>
        </v-col>

        <v-col cols="12" sm="3">
            <span class="text-h5">Assembly Sequence</span>
            <v-select
                item-title="Name"
                item-value="Name"
                label="Assembly Sequence"
                variant="underlined"
                v-model="selectedAssemblySequence.Name"
                :items="assemblySequence"
                :disabled="!jobNumber"
                :readonly="!!prefillData?.JobNum"
                @update:modelValue="asmSeqenceUpdate"
            ></v-select>
        </v-col>

        <v-col cols="12" sm="3">
            <span class="text-h5">Material Sequence</span>
            <v-select
                @update:modelValue="mtlSeqenceUpdate"
                item-title="Name"
                item-value="Name"
                label="Material Sequence"
                variant="underlined"
                v-model="selectedMaterialSequence"
                :disabled="!selectedAssemblySequence || !!prefillData?.JobNum"
                :items="materialSequence"
            ></v-select>
        </v-col>
    </v-row>

    <v-row>
        <v-col cols="12" sm="4">
            <span class="text-h5">Part</span>
            <v-text-field
                label="Part"
                v-model="partNumber"
                variant="underlined"
                readonly
            ></v-text-field>
        </v-col>

        <v-col cols="12" sm="4">
            <span class="text-h5">Last Operation</span>
            <v-select
                label="Last Operation"
                item-title="Name"
                item-value="OprSeq"
                variant="underlined"
                v-model="selectedOperation"
                :items="operations"
                :disabled="!selectedAssemblySequence"
                :readonly="!!prefillData?.JobNum"
            ></v-select>
        </v-col>
    </v-row>

    <v-row v-if="selectedOperation" :retain-focus="false">
        <v-alert :color="warningColor" variant="outlined" width="95%">
            <v-icon
                icon="mdi:mdi-message-alert-outline"
                color="#F57F17"
            ></v-icon>
            <span v-html="getWarning()"> </span>
        </v-alert>
    </v-row>

    <div>
        <v-card variant="flat" class="mx-auto" style="margin-top: 30px">
            <v-overlay
                :loading="loading"
                v-model="blocked"
                contained
                persistent
                class="align-center justify-center"
            >
                <span style="font-size: 20px">
                    {{ blockedMsg }}
                </span>
                <template v-slot:loader>
                    <v-progress-circular indeterminate></v-progress-circular>
                </template>
            </v-overlay>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" sm="12">
                        <span class="text-h5">Quantity</span>
                        <v-chip
                            style="margin-left: 20px; margin-bottom: 10px"
                            color="info"
                            v-if="operations.length"
                        > Required by Job: {{Number(operations[0].RunQty) }}
                        </v-chip>
                        <v-text-field
                            clearable
                            label="Quantity"
                            v-model="QTY"
                            type="number"
                            min="0"
                            :disabled="!selectedAssemblySequence"
                        >
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="11">
                        <span class="text-h5"
                            >Bin
                            <v-tooltip
                                v-model="showBinNumbTooltip"
                                location="end"
                            >
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        size="x-small"
                                        icon
                                        v-bind="props"
                                        @click="
                                            showBinNumbTooltip =
                                                !showBinNumbTooltip
                                        "
                                    >
                                        <v-icon color="blue-lighten-1"
                                            >mdi:mdi-comment-question-outline</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>
                                    Type the Bin Number and press Enter or use
                                    the Scanner Button. For Example:
                                    <v-img
                                        src="/images/ExampleBinBarcode.png"
                                        width="250"
                                        height="200"
                                    ></v-img>
                                </span>
                            </v-tooltip>
                        </span>
                        <v-text-field
                            clearable
                            label="Bin"
                            v-model="binNumber"
                            :disabled="!selectedAssemblySequence"
                            v-on:keydown.enter="getBinInfo"
                            @focusout="searchFocusOut"
                        ></v-text-field>

                        <v-alert v-if="errorBinNum" color="red"
                            >{{ errorMessageBinNum }}
                        </v-alert>
                    </v-col>
                    <v-col cols="12" sm="1">
                        <v-btn
                            class="mt-9"
                            icon="mdi:mdi-barcode-scan"
                            @click="openBarCodeScanner"
                            :disabled="!selectedAssemblySequence"
                        ></v-btn>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="12">
                        <span class="text-h5">Warehouse</span>
                        <v-text-field
                            label="Warehouse"
                            v-model="warehouseCode"
                            readonly
                        >
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row align="center" justify="center">
                    <v-col class="text-center" cols="12">
                        <v-btn
                            :loading="loading"
                            size="x-large"
                            type="submit"
                            @click="submitForm"
                            :disabled="
                                !binNumber || disabled || !QTY || QTY == 0
                            "
                            >Submit
                            <template v-slot:loader>
                                <v-progress-circular
                                    indeterminate
                                ></v-progress-circular>
                            </template>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
import axios from "axios";
import { defineAsyncComponent } from "vue";
const LoadingComponent = defineAsyncComponent(() =>
    import("./../../LoadingComponent.vue")
);

export default {
    components: { StreamBarcodeReader, LoadingComponent },
    props: {
        prefillData: {
            type: Object,
            default: () => ({
                JobNum: null,
                AssemblySeq: null,
                PartNum: null,
                OprSeq: null,
                remaining_qty: null,
                returned_by: null,
            }),
        },
    },
    emits: ["partsReturnedToInventory"],
    data() {
        return {
            loading: false,
            success: false,
            disabled: false,
            errorJobNum: false,
            errorMessageJobNum: "",
            errorBinNum: false,
            errorMessageBinNum: "",
            scanningQR: false,
            scanningBarCode: false,
            selectedAssemblySequence: {
                AsmSeq: null,
                Available: null,
                Mtl: [],
                Name: null,
                Ops: [],
                PartNum: null,
                RequiredQty: null,
                SysRowID: null,
            },
            assemblySequence: [],
            materialSequence: [],
            part: "",
            lastOperation: "",
            quantity: "",
            bin: "",
            warehouseCode: "",
            submitDisabled: true, // Disable the Submit button by default
            jobNumber: null,
            selectedMaterialSequence: null,
            partNumber: null,
            selectedOperation: null,
            operations: [],
            binNumber: null,
            QTY: null,
            showJobNumbTooltip: false,
            showBinNumbTooltip: false,
            warningColor: "",
            blocked: true,
            enterPressed: false,
            isStaged: false,
            blockedMsg:
                "Please Enter Job Number Above And Press Enter To Access",
        };
    },

    async created() {
        if (this.prefillData?.JobNum) {
            await this.prefillForm(this.prefillData);
        }
    },

    watch: {
        selectedOperation(newVal) {
            if (
                (newVal == null || newVal == "") &&
                this.selectedMaterialSequence
            ) {
                this.selectedMaterialSequence = this.selectedMaterialSequence;
            } else {
                this.selectedMaterialSequence = null;
            }
            this.binNumber = null;
            this.warehouseCode = null;
            if (newVal == null || newVal == "") {
                this.isStaged = false;
            }
        },
        jobNumber(newVal) {
            if (newVal === null || newVal === "") {
                this.clearAll();
                this.blocked = true;
                this.disabled = false;
                this.blockedMsg =
                    "Please Enter Job Number Above And Press Enter To Access";
            }
        },
        binNumber(newVal) {
            if (newVal == null || newVal == "") {
                this.warehouseCode = null;
                this.errorBinNum = false;
            }
        },
    },

    methods: {
        openQRScanner() {
            this.scanningQR = true;
        },

        openBarCodeScanner() {
            this.scanningBarCode = true;
        },

        async getBinInfo() {
            this.enterPressed = true;
            this.errorBinNum = false; // Reset the error state before making the API call
            const staging = this.isStaged ? 1 : 0;
            try {
                const response = await axios.get(
                    route("legacy-api.logistics-verifyBin", {
                        bin: this.binNumber,
                        staging: staging,
                    })
                );

                if ((this.errorBinNum = response.data.Status === 0)) {
                    this.errorBinNum = true;
                    if (this.isStaged) {
                        this.errorMessageBinNum =
                            "Bin Number provided is invalid OR is NOT a Staging Bin!";
                    } else {
                        this.errorMessageBinNum =
                            "Bin Number provided is invalid!";
                    }
                } else {
                    this.warehouseCode = response.data.Info[0].WarehouseCode;
                }
            } catch (err) {
                console.log(err);
                this.errorBinNum = false;
                this.errorMessageJobNum =
                    "An error occurred while fetching bin information.";
            }
        },

        async submitForm() {
            if (!this.warehouseCode || this.warehouseCode == "") {
                alert(
                    "Please Press Enter After Entering The Bin Number To Verify The Bin/Warehouse"
                );
            } else if (
                !this.selectedOperation &&
                !this.selectedMaterialSequence
            ) {
                alert(
                    "Please Enter Either a Last Operation OR a Material Sequence"
                );
            } else {
                this.loading = true;
                var mtlValue =
                    this.selectedMaterialSequence &&
                    this.selectedMaterialSequence
                        ? this.selectedMaterialSequence
                        : "";
                mtlValue = mtlValue.split(" ");
                mtlValue = mtlValue.length > 0 ? mtlValue[0] : "";
                var asmSeq = this.selectedAssemblySequence.Name.split(" ");
                var asmResult = asmSeq[0];
                axios
                    .post(route("legacy-api.logistics-returns"), {
                        jobNum: this.jobNumber,
                        asm: asmResult,
                        mtl: mtlValue,
                        part: this.partNumber,
                        lastOp: parseInt(this.selectedOperation),
                        qty: this.QTY,
                        bin: this.binNumber,
                        warehouse: this.warehouseCode,
                        staged: this.isStaged,
                        returned_by: this.prefillData?.returned_by ?? null
                    })
                    .then((response) => {
                        if (response.data.Message) {
                            if (response.data.Status == "S") {
                                this.success = true;
                                this.disabled = true;
                                if (!this.prefillData?.JobNum) {
                                    setTimeout(() => {
                                        location.reload();
                                    }, 4000);
                                } else {
                                    this.$emit("partsReturnedToInventory");
                                }
                            } else {
                                alert(response.data.Message);
                            }
                        } else if (response.data.Status === 1) {
                            this.success = true;
                            this.disabled = true;
                            if (!this.prefillData?.JobNum) {
                                setTimeout(() => {
                                    location.reload();
                                }, 4000);
                            } else {
                                this.$emit("partsReturnedToInventory");
                            }
                        }
                        this.loading = false;
                    });
            }
        },

        async getJobInfo() {
            this.loading = true;
            this.errorJobNum = false; // Reset the error state before making the API call
            this.clearAll();
            this.blocked = true;
            try {
                const response = await axios.get(
                    route("legacy-api.logistics-getJobInfo", {
                        jobNum: this.jobNumber,
                    })
                );

                this.assemblySequence = response.data.Asm;

                if (this.assemblySequence.length === 0) {
                    this.errorJobNum = true;
                    this.errorMessageJobNum = "Job Number provided is invalid!";
                }

                this.blockedMsg =
                    "Please Select An Assembly Sequence To Continue";
            } catch (err) {
                console.log(err);
                this.assemblySequence = [];
                this.errorJobNum = false;
                this.errorMessageJobNum =
                    "An error occurred while fetching job information.";
            } finally {
                this.loading = false;
            }
        },
        getWarning() {
            const last = this.operations.length - 1;
            const option = this.operations.findIndex(
                (item) => item.OprSeq === this.selectedOperation
            );

            if (option === last) {
                this.warningColor = "blue";
                this.isStaged = false;
                var parts = this.selectedAssemblySequence.Name.split(" ");
                var result = parts.slice(1).join(" ");

                this.partNumber = result;

                return "This part is complete! <b>CANNOT</b> be placed in a staging bin";
            } else {
                var parts = this.selectedAssemblySequence.Name.split(" ");
                var result = parts.slice(1).join(" ");

                this.partNumber = result;
                this.warningColor = "#F57F17";
                this.isStaged = true;
                return "This part is not complete! Must be placed in a staging bin";
            }
        },

        async onDecodeQR(result) {
            let decoded = [];
            decoded = JSON.parse(result);

            let asmSeq = "";
            this.scanningQR = false;
            if (decoded.length) {
                asmSeq = decoded[3] + " " + decoded[0];
                this.jobNumber = decoded[2];
                await this.getJobInfo();
                this.assemblySequence.forEach((ele) => {
                    if (ele.Name === asmSeq) {
                        this.selectedAssemblySequence.Name = asmSeq;
                        this.partNumber = decoded[0];
                        this.materialSequence = ele.Mtl;
                        this.operations = ele.Ops;
                        this.selectedOperation = Number(decoded[4]);

                    }
                });

                this.selectedMaterialSequence = null;
                this.binNumber = null;
                this.warehouseCode = null;
                this.QTY = null;

                this.blocked = false;
            }
            this.selectedMaterialSequence = null;
        },

        async onDecodeBC(result) {
            const code = result.replace(/\$I/g, "");
            this.binNumber = code;
            this.scanningBarCode = false;
            await this.getBinInfo();
        },

        closeQRScanner() {
            this.scanningQR = false;
        },

        closeBarCodeScanner() {
            this.scanningBarCode = false;
        },
        mtlSeqenceUpdate(newValue) {
            // Split the string into an array based on the space character
            var parts = newValue.split(" ");
            var result = parts.slice(1).join(" ");

            this.partNumber = result;
            this.selectedMaterialSequence = result;
            this.selectedOperation = null;
            this.binNumber = null;
            this.warehouseCode = null;
            this.QTY = null;
        },
        asmSeqenceUpdate(value) {
            this.operations = [];
            if (value !== null) {
                this.assemblySequence.forEach((ele) => {
                    if (ele.Name === value) {
                        this.partNumber = ele.PartNum;
                        this.materialSequence = ele.Mtl;
                        this.operations = ele.Ops;

                    }
                });

                //this.operations.unshift({ Name: "", OprSeq: "" });
                this.selectedOperation = null;
                this.selectedMaterialSequence = null;
                this.binNumber = null;
                this.warehouseCode = null;
                this.QTY = null;

                this.blocked = false;
            }
            this.selectedMaterialSequence = null;
        },
        async searchFocusOut() {
            if (!this.enterPressed) {
                await this.getBinInfo();
            }

            this.enterPressed = false;
        },
        clearAll() {
            this.selectedAssemblySequence = {
                AsmSeq: null,
                Available: null,
                Mtl: [],
                Name: null,
                Ops: [],
                PartNum: null,
                RequiredQty: null,
                SysRowID: null,
            };
            this.selectedMaterialSequence = null;
            this.selectedOperation = null;
            this.operations = [];
            this.assemblySequence = [];
            this.materialSequence = [];
            this.partNumber = null;
            this.QTY = "";
            this.binNumber = "";
            this.warehouseCode = "";
        },
        async prefillForm(data) {
            try {
                this.loading = true;
                this.blocked = true;

                // Set job number and fetch related data
                this.jobNumber = data.JobNum;
                await this.getJobInfo();

                // Find matching assembly
                const matchAsm = this.assemblySequence.find(item =>
                    item.Name?.startsWith(String(data.AssemblySeq))
                );

                if (!matchAsm) return;

                this.selectedAssemblySequence.Name = matchAsm.Name;
                this.asmSeqenceUpdate(matchAsm.Name);

                // Set part number if it matches
                if (data.PartNum === matchAsm.PartNum) {
                    this.partNumber = matchAsm.PartNum;
                }

                // Find matching operation
                const matchOpr = matchAsm.Ops?.find(
                    opr => opr.OprSeq === data.OprSeq
                );

                if (matchOpr) {
                    this.selectedOperation = matchOpr.OprSeq;
                    this.getWarning();
                }

                // Set quantity
                if (this.selectedOperation && data.remaining_qty) {
                    this.QTY = data.remaining_qty;
                }

            } catch (err) {
                console.error("Prefill failed:", err);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style>
.overlay {
    top: 50%;
    left: 50%;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 10px;
    border-radius: 4px;
}

/* DEV */

@media (min-width: 850px) {
    :deep(video[data-v-3994e62f]) {
        width: 975px !important;
    }
}

/* DEV */

@media (min-width: 850px) {
    :deep(video[data-v-9c322c14]) {
        width: 975px !important;
    }
}

/* LIVE */

@media (min-width: 850px) {
    :deep(video[data-v-5009edfa]) {
        width: 975px !important;
    }
}

/* LIVE */

@media (min-width: 850px) {
    :deep(video[data-v-14d9a7aa]) {
        width: 975px !important;
    }
}

/* DEV */

@media (min-height: 500px) {
    :deep(video[data-v-9c322c14]) {
        width: 975px !important;
    }
}

/* DEV */

@media (min-height: 500px) {
    :deep(video[data-v-3994e62f]) {
        width: 975px !important;
    }
}

/* LIVE */

@media (min-height: 500px) {
    :deep(video[data-v-5009edfa]) {
        width: 975px !important;
    }
}

/* LIVE */

@media (min-height: 500px) {
    :deep(video[data-v-14d9a7aa]) {
        width: 975px !important;
    }
}
</style>
